import React from 'react';

import { Text } from '@thefarmersfront/kitchen';

/**
 * [입고관리 > 입고요청관리] 요청상태가 [요청취소]인 상태만 선택 후, 검수확인용 거래명세서 다운로드 시의 다이알로그
 */
const DialogCanceledStatusSpecifications = () => {
  return (
    <Text element="span" size="large">
      <Text element="span" size="large" weight="semi-bold">
        [요청취소]{' '}
      </Text>
      상태의 요청은 거래명세서를 다운로드 받을 수 없습니다.
    </Text>
  );
};

export default DialogCanceledStatusSpecifications;
